import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '@/config/seo';

/**
 * Organization schema for site-wide structured data.
 * Rendered in layout or on key pages (e.g. Index).
 */
export function OrganizationJsonLd() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SEO_CONFIG.siteName,
    url: SEO_CONFIG.baseUrl,
    logo: {
      '@type': 'ImageObject',
      url: `${SEO_CONFIG.baseUrl}/pwa-512.png`,
    },
    description: SEO_CONFIG.defaultDescription,
    areaServed: {
      '@type': 'AdministrativeArea',
      name: 'Île-de-France',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'contact@fullbook.fr',
      availableLanguage: 'French',
    },
    sameAs: [
      'https://www.instagram.com/fullbook.fr',
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
